
import {
	Component,
	Emit,
	Prop,
	Watch,
} from 'vue-property-decorator';
import Vue from 'vue';
import { UtilHelper } from '@/util/helper';

@Component
export default class DollarInput extends Vue {
	@Prop()
	public errorMessage!: string;

	@Prop({ default: 'auto' })
	public hideDetails!: boolean | string;

	@Prop()
	public hint!: string;

	@Prop()
	public id!: string;

	public inputValue = UtilHelper.formatDollar(0, '');

	@Prop()
	public messages!: string | string[];

	@Prop({ default: false })
	public persistentHint!: boolean;

	@Prop({ default: 0 })
	public value!: number;

	get dollarValue(): number {
		return UtilHelper.convertDollarStringToNumber(this.inputValue);
	}

	@Emit('blur')
	public emitBlur(): number {
		return this.dollarValue;
	}

	@Emit('enter')
	public emitEnter(): number {
		return this.dollarValue;
	}

	@Emit('focus')
	public emitFocus(): number {
		return this.dollarValue;
	}

	@Emit('input')
	public emitInput(): number {
		return this.dollarValue;
	}

	public onBlur(): void {
		this.setAndFormatInput(this.inputValue);
		this.emitBlur();
	}

	public onInput(value: string): void {
		this.$nextTick(() => {
			this.inputValue = UtilHelper.convertValueToFormattedDollarStringInPlace(value, '');
			this.emitInput();
		});
	}

	public onKeyUp(event: KeyboardEvent): void {
		if (event.key === 'Enter') {
			this.setAndFormatInput(this.inputValue);
			this.emitEnter();
		}
	}

	@Watch('value')
	public watchValue(value: number): void {
		const isValueDifferent = value !== UtilHelper.convertDollarStringToNumber(this.inputValue);

		if (isValueDifferent) {
			this.setAndFormatInput(value);
		}
	}

	private setAndFormatInput(value: number | string): void {
		this.inputValue = UtilHelper.formatDollar(value, '');
	}
}
